import { compose, head, split } from 'ramda';

const webCatalog = compose(head, split('.'))(window.location.host);

export default webCatalog;
